import { useEffect } from "react";
import { DropDownEdit2, ToggleButton, DecimalInput } from "components";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { useInput } from "hooks";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveGasTextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const isUpTo = useInput(false);
  const val = useInput("0.05");
  const unit = useInput("per gallon");
  const isPurchase = useInput(true);
  const pVal = useInput("");
  const pType = useInput("");
  const suffix = useInput("");

  const typeData = [
    { label: "$", value: "$" },
    { label: "Unit", value: "Unit" },
  ];
  const valueData = [{ id: "double savings", title: "double savings" }];
  const unitData = [
    { label: "per gallon", value: "per gallon" },
    { label: "per liter", value: "per liter" },
  ];

  const formatFirstLine = (v, u) => {
    if (v === "double savings") {
      return `double savings${u ? ` ${u}` : ""}`;
    }
    return `$${formatDollarValue(v)}${u ? ` ${u}` : ""}`;
  };
  const formatPurchase = (isP, pV, pT) => {
    if (isP) {
      if (pT === "$") {
        return ` w/purchase/$${formatDollarValue(pV)}`;
      } else {
        return ` w/purchase/${pV}`;
      }
    }
    return "";
  };

  const handleUpdateValue = (isUT, v, u, isP, pV, pT, suf) => {
    onChange(
      `Earn${isUT ? " Up To" : ""} ${formatFirstLine(v, u)}${formatPurchase(
        isP,
        pV,
        pT
      )}${suf ? ` ${suf}` : ""}`
    );
  };

  useEffect(() => {
    if (value.startsWith("Earn")) {
      let main = value.slice(4).trimStart();
      if (main.startsWith("Up To")) {
        main = main.slice(5).trimStart();
        isUpTo.setValue(true);
      } else {
        isUpTo.setValue(false);
      }
      const pIdx = main.indexOf("w/purchase/");
      if (pIdx > 0) {
        let firstPart = main.slice(0, pIdx).trim();
        if (firstPart.endsWith("per gallon")) {
          unit.setValue("per gallon");
          firstPart = firstPart.slice(0, -10).trim();
        } else {
          unit.setValue("per liter");
          firstPart = firstPart.slice(0, -9).trim();
        }
        if (firstPart.startsWith("$")) {
          val.setValue(firstPart.slice(1));
        } else if (firstPart === "double savings") {
          val.setValue("double savings");
        }
        main = main.slice(pIdx + 11);
        const sufIdx = main.indexOf(" ");
        let pv = "";
        if (sufIdx > 0) {
          pv = main.slice(0, sufIdx).trim();
          suffix.setValue(main.slice(sufIdx + 1));
        } else {
          pv = main.trim();
          suffix.setValue("");
        }
        if (pv.startsWith("$")) {
          pType.setValue("$");
          pVal.setValue(pv.slice(1));
        } else {
          pType.setValue("Unit");
          pVal.setValue(pv);
        }
      }
    }
    return () => { };
  }, [value]);

  return (
    <>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <div className="mt-3">Earn</div>

        <ToggleButton className="mt-3 mx-2" style={{ width: '30%' }} label="Up To" value={isUpTo.value}
          onChange={(e) => {
            isUpTo.setValue(e);
            handleUpdateValue(e, val.value, unit.value, isPurchase.value, pVal.value, pType.value, suffix.value);
          }}
        />

        <DropDownEdit2 label="Value" data={valueData} className="mx-2"
          value={val.value} width={120} ignoreKeyPress
          onChange={(e) => {
            val.setValue(e);
            handleUpdateValue(isUpTo.value, e, unit.value, isPurchase.value, pVal.value, pType.value, suffix.value);
          }}
        />

        <LabelledSelect label="Unit" options={unitData} value={unit.value}
          onChange={(e) => {
            unit.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, e, isPurchase.value, pVal.value, pType.value, suffix.value);
          }} />
      </div>
      <div className="p-2 d-flex justify-content-between align-items-center">
        <ToggleButton className="mt-3" label="w/purchase" value={isPurchase.value}
          onChange={(e) => {
            isPurchase.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, unit.value, e, pVal.value, pType.value, suffix.value);
          }}
        />

        <LabelledInput label="Value" placeholder="Value" style={{ width: '94%' }} disabled={!isPurchase.value}
          allowclear="true" inputType="float" value={pVal.value} className="ml-2"
          onChange={(e) => {
            pVal.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, unit.value, isPurchase.value, e, pType.value, suffix.value);
          }}
        />

        <LabelledSelect label="Type" style={{ width: '94%' }} className="ml-2"
          options={typeData} disabled={!isPurchase.value} value={pType.value}
          onChange={(e) => {
            pType.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, unit.value, isPurchase.value, pVal.value, e, suffix.value);
          }} />

        <LabelledInput label="Suffix" placeholder="Suffix" className="ml-2"
          allowclear="true" value={suffix.value}
          onChange={(e) => {
            suffix.setValue(e);
            handleUpdateValue(isUpTo.value, val.value, unit.value, isPurchase.value, pVal.value, pType.value, e);
          }}
        />
      </div>
    </>
  );
};